/**
 * Stats Counter Bar — GSAP Scroll-Triggered Count-Up
 *
 * Numbers count up from 0 to their target value when the
 * section enters the viewport. Uses tabular-nums in CSS
 * to prevent layout shift during the count. Fires once,
 * staggered per stat with a wave effect.
 *
 * Supports optional prefix/suffix via data attributes,
 * locale-formatted comma separators, and reduced motion.
 *
 * Requires GSAP + ScrollTrigger (loaded by the section).
 */
(function () {
  'use strict';

  /* ══════════════════════════════════════════
   *  DEPENDENCY LOADER
   * ══════════════════════════════════════════ */

  function waitForDeps(cb) {
    if (window.gsap && window.ScrollTrigger) return cb();
    var check = setInterval(function () {
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(check);
        cb();
      }
    }, 50);
    setTimeout(function () { clearInterval(check); }, 8000);
  }

  /* ══════════════════════════════════════════
   *  FORMAT NUMBER — locale comma separators
   * ══════════════════════════════════════════ */

  function formatNumber(n) {
    return Math.round(n).toLocaleString();
  }

  /* ══════════════════════════════════════════
   *  INIT SECTION
   * ══════════════════════════════════════════ */

  function initStatsBar(sectionId) {
    var section = document.querySelector('[data-stats-bar-id="' + sectionId + '"]');
    if (!section) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    gsap.registerPlugin(ScrollTrigger);

    var valueEls = section.querySelectorAll('.hp-stats-bar__value');
    var triggers = [];

    if (valueEls.length === 0) return;

    /* ── Reduced motion: show final values immediately ── */
    if (reducedMotion) {
      valueEls.forEach(function (el) {
        var target = parseInt(el.dataset.target, 10) || 0;
        el.textContent = formatNumber(target);
      });
      section._statsBarCleanup = function () {};
      return;
    }

    /* ── Set initial state: all values show "0" ── */
    valueEls.forEach(function (el) {
      el.textContent = '0';
    });

    /* ── ScrollTrigger: count up when section enters viewport ── */
    var st = ScrollTrigger.create({
      trigger: section,
      start: 'top 85%',
      once: true,
      onEnter: function () {
        valueEls.forEach(function (el, idx) {
          var target = parseInt(el.dataset.target, 10) || 0;
          var obj = { val: 0 };

          gsap.to(obj, {
            val: target,
            duration: 2,
            delay: idx * 0.15,
            ease: 'power2.out',
            onUpdate: function () {
              el.textContent = formatNumber(obj.val);
            }
          });
        });
      }
    });

    triggers.push(st);

    /* ── Cleanup for Shopify editor ── */
    section._statsBarCleanup = function () {
      triggers.forEach(function (t) { t.kill(); });
      triggers = [];
    };
  }

  /* ══════════════════════════════════════════
   *  BOOT + SHOPIFY EDITOR EVENTS
   * ══════════════════════════════════════════ */

  function boot() {
    document.querySelectorAll('[data-stats-bar-id]').forEach(function (el) {
      var id = el.dataset.statsBarId;
      if (!el._statsBarInit) {
        el._statsBarInit = true;
        waitForDeps(function () { initStatsBar(id); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-stats-bar-id]');
    if (el) {
      el._statsBarInit = false;
      waitForDeps(function () {
        initStatsBar(el.dataset.statsBarId);
        ScrollTrigger.refresh();
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-stats-bar-id]');
    if (el && el._statsBarCleanup) el._statsBarCleanup();
  });
})();
